import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import MovieCard from '../components/MovieCard'
import { getMoviesByGenre } from '../lib/supabase'

export default function GenrePage() {
  const { slug } = useParams()
  const [movies, setMovies] = useState([])
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    getMoviesByGenre(slug, page).then((data) => {
      setMovies((prev) => page === 1 ? data : [...prev, ...data])
      setLoading(false)
    }).catch(() => setLoading(false))
  }, [slug, page])

  return (
    <div className="pt-20 px-4 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold capitalize mb-6">{slug.replace(/-/g, ' ')}</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
        {movies.map((m) => <MovieCard key={m.id} movie={m} />)}
      </div>
      {!loading && movies.length > 0 && (
        <div className="text-center py-8">
          <button onClick={() => setPage((p) => p + 1)} className="px-6 py-3 bg-dark-800 border border-dark-700 rounded-lg text-gray-300 hover:text-white hover:border-primary-500/50 transition-colors">
            Muat Lainnya
          </button>
        </div>
      )}
      {loading && (
        <div className="flex justify-center py-8">
          <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
        </div>
      )}
    </div>
  )
}
